import React from 'react';
import { useDraggable } from '@dnd-kit/core';

function Draggable({ children, id, onIsDragging }: { children: React.ReactNode, id: string, onIsDragging?: (isDragging: boolean) => void }) {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: id,
    });

    React.useEffect(() => {
        onIsDragging?.(isDragging);
    }, [isDragging, onIsDragging]);

    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    } : undefined;


    return (
        <button ref={setNodeRef} style={{ ...style, width: '100%' }} {...listeners} {...attributes}>
            {children}
        </button>
    );
}

export default Draggable;